import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import ProductassetDashboard from '../ProductassetDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function ProductassetPage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < ProductassetDashboard />
    )

}